import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type { RequestResponse } from '@/types';

export type PostOmnichannelTestAiPayload = {
  /** Prompt / context sent to the AI (e.g. latest customer message). */
  message: string;
  /** Conversation id (number or string per API). */
  conversationId: string | number;
};

/**
 * POST test AI — queues work on the server; the draft arrives on Socket.IO `new_message` with `message.type === "ai_response"`.
 */
export async function postOmnichannelTestAi(
  payload: PostOmnichannelTestAiPayload
): Promise<RequestResponse<unknown>> {
  const response = await axiosInstance.post<RequestResponse<unknown>>(
    endpoints.omnichannel.aiTest,
    payload
  );
  return response.data;
}
